import data from './data.json';


// @ts-ignore
export default data.map(({flag, name, alpha2Code, alpha3Code, callingCodes}) => ({
    flag,
    name,
    alpha2Code,
    label: `${name} ${alpha2Code} ${alpha3Code} +${callingCodes[0]}`,
    value: `+${callingCodes[0]}`
}))
